import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  standalone: false,
  name: 'dateFormatWithTime'
})
export class DateFormatWithTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return dayjs(value).format('MMMM Do YYYY HH:mm:ss');
  }

}
